import ActivityModel from '@/Modules/Activity/ActivityModel.js'
import DatasetService from '@/Modules/Dataset/DatasetService.js'
import { INCREASE_TAB_COUNT } from '@/Modules/Quote/Components/QuoteForm/QuoteFormModule.js'
import { mapActions } from 'vuex'

export default {
  name: 'EditForm',

  props: {
    activityData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entities: {
      type: Array,
      default: () => {
        return []
      }
    },
    users: {
      type: Array,
      default: () => {
        return []
      }
    },
    handleCreate: {
      type: Function,
      default: null,
    },
    handleUpdate: {
      type: Function,
      default: null,
    }
  },

  data() {
    return {
      activity: new ActivityModel(this.activityData),
      ActivityModel,
      userItems: this.users
    }
  },

  created() {
    this.fetchUsers()
  },

  methods: {
    ...mapActions('QuoteFormModule', {
      increaseTabCount: INCREASE_TAB_COUNT
    }),

    getActivityEntityResponsibleUsers() {
      this.fetchUsers()
      this.activity.userId = {}
    },

    fetchUsers() {
      DatasetService
        .listOptionsByTagAndValue('users', 'entity_id', this.$selectValue(this.activity, 'entityId'))
        .then(users => this.userItems = users)
    },

    cancel() {
      this.$emit('onCancel')
    },

    getActivityPayload() {
      return {
        subject: this.activity.subject,
        type: this.$selectValue(this.activity, 'type'),
        priority: this.$selectValue(this.activity, 'priority'),
        description: this.activity.description,
        activityDate: this.activity.activityDate,
        entityId: this.$selectValue(this.activity, 'entityId'),
        userId: this.$selectValue(this.activity, 'userId'),
      }
    }
  }
}
